export default function Arbeitsgruppe() {
  return (
    <section>
      <h1>Arbeitsgruppe</h1>
      <h2>Gemeinsam für mehr Inklusion: Der DUOday</h2>
      <p>
        Der DUOday wird von einem starken Netzwerk von Arbeitgeber:innen und
        engagierten Partnern getragen und organisiert. Im Mittelpunkt stehen
        dabei die Schirmherr:innen, die enercity, die Landeshauptstadt Hannover
        sowie die Region Hannover, die den DUOday maßgeblich unterstützen und
        begleiten. Zu den teilnehmenden Unternehmen des ersten DUOdays 2025
        gehören unter anderem die Sparkasse Hannover, die Continental AG, die BG
        Phoenics GmbH sowie die Stadt Barsinghausen. Ein besonderer Bestandteil
        des Netzwerks sind die Werkstätten, die von Beginn an aktiv beteiligt
        sind: die Hannoversche Werkstätten, die Caritas Werkstätten Hannover und
        die Lebenshilfe Seelze. Sie leisten einen wichtigen Beitrag zur
        erfolgreichen Umsetzung des DUOdays. Unterstützt wird das Projekt zudem
        durch weitere Partner wie den Integrationsfachdienst, die AWO Hannover
        sowie die Einheitlichen Ansprechstellen für Arbeitgeber (EAA). Gemeinsam
        setzen sich die genannten Beteiligten dafür ein, Menschen mit
        Beeinträchtigungen neue Perspektiven im Arbeitsleben zu eröffnen und
        Inklusion aktiv erlebbar zu machen.
      </p>
    </section>
  );
}
